<template>
	<div>
		<sm-card no-header>
			<div slot="body" style="position: relative;">
				<el-button type="primary" size="mini" @click="insert()">新建</el-button>
				<div style="position: absolute;right: 10px;top: -3px;">
					<el-input style="width: 200px;" size="small" placeholder="请输入采集站名" v-model="searchParm.name">
						<el-button slot="append" icon="el-icon-search" @click="list()"></el-button>
					</el-input>
				</div>
			</div>
		</sm-card>
		<sm-card no-header class="table">
			<div slot="body">
				<el-table ref="usertable" :data="tableData.records" border
					:header-cell-style="{'background-color':'#f0f0f0','color':'#262626','height':'40px','padding':'0','font-weight':'normal'}"
					:cell-style="{'color':'#595959','height':'40px','padding':'0'}" style="margin-bottom: 20px;">
					<el-table-column prop="name" label="采集站名">
					</el-table-column>
					<el-table-column prop="no" label="采集站编号">
					</el-table-column>
					<el-table-column prop="len" label="采样长度">
					</el-table-column>
					<el-table-column prop="pack" label="数据总包数">
					</el-table-column>
					<el-table-column prop="rate" label="采样率">
					</el-table-column>
					<el-table-column prop="ent_name" label="企业名">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="edit('编辑',scope.row)">
								编辑
							</el-button>
							<el-button type="text" size="small" @click="remove(scope.row)">
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="searchParm.current"
						:page-size="searchParm.size" layout="total, prev, pager, next,jumper" :total="tableData.total">
					</el-pagination>
				</div>
			</div>
		</sm-card>
		<insert :isShow.sync="showLookDialog"></insert>
		<edit :isShow.sync="showEditDialog" :dialogObj="editObj"></edit>
	</div>
</template>
<script>
	import smCard from "@c/smCard.vue"
	import smFooter from "@c/smFooter.vue"
	import insert from "./insert.vue"
	import edit from "./edit.vue"
	export default {
		components: {
			smCard,
			smFooter,
			insert,
			edit
		},
		data() {
			return {
				eqName: "",
				tableData: {
					records: [],
				},
				searchParm: {
					size: 20,
					current: 1
				},
				showLookDialog: false,
				showEditDialog: false,
				editObj: {}
			}
		},
		methods: {
			insert() {
				this.showLookDialog = true;
			},
			edit(title, row) {
				this.editObj = {
					title: title,
					row: row,
				};
				this.showEditDialog = true;
			},
			remove(row) {
				this.$confirm('是否删除(' + row.name + ',' + row.no + ')', '删除采集站', {
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$remove("/backend-api/eqp/sta/remove/" + row.id, null).then((res) => {
						if (res.code == 1000) {
							this.$message.success(res.msg);
							//刷新表格
							this.list();
						} else {
							this.$message.error(res.msg);
						}
					});
				}).catch(() => {});
			},
			//分页选择页面回调
			handleCurrentChange(val) {
				this.searchParm.current = val;
				this.list();
			},
			list() {
				this.$get("/backend-api/eqp/sta/list", this.searchParm).then((res) => {
					if (res.code == 1000) {
						this.tableData = res.data;
						console.log(res.data);
					} else {
						this.$message.error(res.msg);
					}
				});
			}
		},
		mounted() {
			this.list();
		}
	};
</script>
<style lang='scss' scoped>
	@import "@style/userCenter.scss";

	.table-header .el-select {
		width: 100px;
		margin-right: 10px;
	}

	.el-form-item {
		display: flex !important;
	}

	.el-form-item .el-form-item__content {
		flex: 1;
	}
</style>
